import React, { useState } from "react";
import MusicPlayer from "./components/musicPlayer/musicPlayer";
import Lyrics from "./components/lyrics/lyrics";
import "./styles/twoSections.css";

function App() {
  const [dataForLyrics, setDataForLyrics] = useState({});
  const [hasReachedLastLyric, setHasReachedLastLyric] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState("");
  const [occasions, setOccasions] = useState({
    retirement: false,
    anniversary: false,
    promotion: false,
    other: false,
  });
  const [submitted, setSubmitted] = useState(false);

  const handleCheckbox = (type) => {
    setOccasions((prev) => ({ ...prev, [type]: !prev[type] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const selectedOccasions = Object.entries(occasions)
      .filter(([_, checked]) => checked)
      .map(([type]) => type)
      .join(", ");
    try {
      await fetch("https://formspree.io/f/mgvgpzqz", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          occasions: selectedOccasions || "Not specified",
          source: "TimFortson Music Player"
        }),
      });
      setSubmitted(true);
      setEmail("");
      setOccasions({ retirement: false, anniversary: false, promotion: false, other: false });
      // Reset modal after 3 seconds
      setTimeout(() => {
        setShowModal(false);
        setSubmitted(false);
      }, 3000);
    } catch (err) {
      console.error("Form submission error:", err);
    }
  };

  // Function to handle data updates from the child component
  const handleLyricsDataFromChild = (data) => {
    setDataForLyrics(data);
  };

  return (
    <div className="App">
      <div className="two-sections-layout">
        <div className="section-left">
          {<MusicPlayer getDataForLyrics={handleLyricsDataFromChild} hasReachedLastLyric={hasReachedLastLyric} />}
        </div>
        <div className="section-right">
          <Lyrics
            trackId={dataForLyrics.trackId}
            currentTime={dataForLyrics.currentTime}
            onLastLyricReached={setHasReachedLastLyric}
          />
        </div>
      </div>

      {/* Attribution */}
      <div
        className="attribution-container"
        onMouseEnter={() => setShowModal(true)}
        onClick={() => setShowModal(true)}
      >
        <span className="attribution-button">
          Created with ♥ by Mojo Solo
        </span>
        <p className="attribution-congrats">Congratulations Tim - we loved working with you!</p>

        {/* Modal */}
        {showModal && (
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={(e) => {
                e.stopPropagation();
                setShowModal(false);
                setSubmitted(false);
                setEmail("");
                setOccasions({ retirement: false, anniversary: false, promotion: false, other: false });
              }}
            >
              ×
            </button>
            {submitted ? (
              <div className="modal-success">
                <p>Thanks! We'll be in touch soon.</p>
              </div>
            ) : (
              <>
                <h3>Celebrate a special moment</h3>
                <p className="modal-description">What's the occasion?</p>
                <div className="modal-checkboxes">
                  <label className="modal-checkbox">
                    <input
                      type="checkbox"
                      checked={occasions.retirement}
                      onChange={() => handleCheckbox("retirement")}
                    />
                    <span>Retirement</span>
                  </label>
                  <label className="modal-checkbox">
                    <input
                      type="checkbox"
                      checked={occasions.anniversary}
                      onChange={() => handleCheckbox("anniversary")}
                    />
                    <span>Anniversary</span>
                  </label>
                  <label className="modal-checkbox">
                    <input
                      type="checkbox"
                      checked={occasions.promotion}
                      onChange={() => handleCheckbox("promotion")}
                    />
                    <span>Promotion</span>
                  </label>
                  <label className="modal-checkbox">
                    <input
                      type="checkbox"
                      checked={occasions.other}
                      onChange={() => handleCheckbox("other")}
                    />
                    <span>Other</span>
                  </label>
                </div>
                <p className="modal-pricing">Starting at $999</p>
                <form onSubmit={handleSubmit} className="modal-form">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="modal-input"
                  />
                  <button type="submit" className="modal-cta">
                    Send Me Info
                  </button>
                </form>
                <a
                  href="https://mojosolo.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="modal-link"
                >
                  Learn more about mojosolo.com
                </a>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
